Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var SlideItem = /** @class */ (function (_super) {
    tslib_1.__extends(SlideItem, _super);
    function SlideItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startXPos = 0;
        _this.currentMoveXPos = 0;
        return _this;
    }
    SlideItem.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (ref) { return _this.props.getRef(ref); }, className: this.rootClasses, style: { marginRight: this.props.rightMargin + "px" }, onTouchStart: function (event) { return _this.handleTouchStart(event); }, onTouchMove: function (event) { return _this.handleTouchMove(event); }, onTouchEnd: function (event) { return _this.handleTouchEnd(event); }, onClick: function () { return _this.props.onClick(); } }, this.props.content));
    };
    Object.defineProperty(SlideItem.prototype, "movedDeltaX", {
        get: function () {
            return this.currentMoveXPos - this.startXPos;
        },
        enumerable: true,
        configurable: true
    });
    SlideItem.prototype.handleTouchStart = function (event) {
        this.startXPos = this.currentMoveXPos = this.getTouchXPos(event);
        this.props.startMoveHandler();
    };
    SlideItem.prototype.handleTouchMove = function (event) {
        this.currentMoveXPos = this.getTouchXPos(event);
        this.props.moveHandler(this.movedDeltaX);
    };
    SlideItem.prototype.handleTouchEnd = function (event) {
        this.props.endMoveHandler(this.movedDeltaX);
    };
    SlideItem.prototype.getTouchXPos = function (event) {
        var touchPoint = event.nativeEvent.changedTouches[0];
        return touchPoint.clientX;
    };
    Object.defineProperty(SlideItem.prototype, "rootClasses", {
        get: function () {
            return [
                this.props.classes.container,
                'slide-item',
                this.props.isLastSlide && 'last-slide-item'
            ]
                .filter(Boolean)
                .join(' ');
        },
        enumerable: true,
        configurable: true
    });
    return SlideItem;
}(React.Component));
exports.SlideItem = SlideItem;
